export const howToWork = [
  {
    title: "recon_how_to_work_list_title_1",
    description: "recon_how_to_work_list_description_1",
    link: "/how-to-work/1.mp4"
  },
  {
    title: "recon_how_to_work_list_title_2",
    description: "recon_how_to_work_list_description_2",
    link: "/how-to-work/2.mp4"
  },
  {
    title: "recon_how_to_work_list_title_3",
    description: "recon_how_to_work_list_description_3",
    link: "/how-to-work/3.mp4"
  },
]